export default __webpack_public_path__ + "static/media/NotoSans-Light.8cc1e6ef.ttf";